import './App.css';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Dashboard from "./component/pages/Dashboard";
import News from "./component/pages/News";
import Login from "./component/pages/Login";
import addnew from "./component/pages/addnew";


function App() {
    return (
        <>
            <Router>
                
                <div>
                    <Switch>
                        <Route path="/" exact component={Dashboard} />
                        <Route path="/news" exact component={News} />
                        <Route path="/login" exact component={Login} />
                        <Route path="/addnew" exact component={addnew} />
                    </Switch>
                </div>
            </Router>
        </>
    );
}

export default App;
